module.exports = __webpack_public_path__ + "media/applicants/goodmorning-925b7121.jpg";